import { Download } from 'lucide-react';

import { Button } from '@/components/ui/button';
import useInstallPrompt from '@/hooks/useInstallPrompt';

const PwaInstallButton = ({ variant = 'member', className = '', children = 'Install App' }) => {
  const { canInstall, promptInstall } = useInstallPrompt();

  if (!canInstall) return null;

  const buttonVariant = variant === 'member' ? 'memberGold' : 'outline';

  return (
    <Button type="button" size="sm" variant={buttonVariant} className={className} onClick={promptInstall}>
      <Download className="h-4 w-4 mr-2" />
      {children}
    </Button>
  );
};

export default PwaInstallButton;
